<template>
  <div>
    <table-widget :items="files" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
      <template slot="file-input">
        <div class="pull-right">
          <b-form @submit.prevent="uploadNewFile()">
            <div class="file-input-div">
              <label for="file-input" :class="{ 'invalid-label': $v.form.newUploadedFile.$error }">File</label>
              <b-form-file id="file-input" v-model="form.newUploadedFile" plain />
              <span class="span-feedback invalid-feedback inline-span" v-if="$v.form.newUploadedFile.$error">You must select a file.</span>
            </div>
            <b-button type="submit" class="upload-button" ><font-awesome-icon icon="plus" /> Add New File</b-button>
          </b-form>
        </div>
      </template> 
      <template slot="content">
        <b-table striped
            :items="files"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            small>
          <template slot="file" slot-scope="data">
            <a :href="getFileHref(data.item)">{{ data.item.fileName }}</a>
          </template>
          <template slot="date" slot-scope="data">
            {{ data.item.createdDate | formatDateTime }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import sitesApi from "../../api/sites";
import { required } from "vuelidate/lib/validators";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      form: {
        newUploadedFile: null
      },
      files: [],
      fields: [{ key: "file" }, { key: "date" }, { key: "createdBy" }],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    siteId: {
      required: true
    }
  },

  components: {
    "table-widget": TableWidget
  },

  validations: {
    form: {
      newUploadedFile: {
        required
      }
    }
  },

  watch: {
    files: function() {
      this.totalRows = this.files.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getFileHref: function(file) {
      return (
        process.env.VUE_APP_BASE_URI +
        "/api/Downloads/SiteFile?id=" +
        file.siteFileId
      );
    },

    uploadNewFile: function() {
      var that = this;
      this.$v.$touch();

      // only upload if there is a file to upload
      if (!this.$v.$invalid) {
        var formData = {};
        formData.siteId = this.siteId;
        var fileList = [];
        fileList.push(this.form.newUploadedFile);
        sitesApi
          .postSiteFile(formData, fileList)
          .then(function() {
            that.$v.$reset();
            that.form.newUploadedFile = null;
            // Toastr Message
            toastr.options = ToastrSettings;
            toastr.success("The file has been uploaded.", "Success");
            that.getFiles();
          })
          .catch(function(error) {
            console.log(error);
            toastr.options = ToastrSettings;
            toastr.error("File could not be uploaded.", "Error");
          });
      }
    },

    getFiles: function() {
      var that = this;
      sitesApi
        .getSiteFiles(this.siteId)
        .then(function(response) {
          that.files = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  created() {
    this.getFiles();
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}

.file-input-div {
  display: inline-block;
  margin-bottom: 10px;
}

.upload-button {
  float: right;
  margin-top: 10px;
}

.span-feedback.inline-span {
  display: inline;
  font-size: 90%;
}

.invalid-label {
  color: #dc3545;
}
</style>
